import { SET_CHERTO_EXPERIMENTS } from 'actions/actionConstants'
import { createAppReducer } from 'lib/redux/reducerUtils'

export const initialChertoState: App.ChertoState = {
  chertoExperiments: {},
}

export default createAppReducer<App.ChertoState>(initialChertoState, {
  [SET_CHERTO_EXPERIMENTS]: (state, action) => {
    const chertoExperiments = { ...state.chertoExperiments }

    Object.entries(action.experiments).forEach(([experimentKey, nextExperiment]) => {
      if (!nextExperiment) {
        delete chertoExperiments[experimentKey]
        return
      }

      const previousExperiment = state.chertoExperiments?.[experimentKey]
      chertoExperiments[experimentKey] = previousExperiment ? { ...previousExperiment, ...nextExperiment } : nextExperiment
    })

    return {
      chertoExperiments,
    }
  },
})
